export const log_error = (class_name, error, function_name='') => {
  console.log(class_name)
  console.log(function_name)
  console.log(error)
}